<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    activeKey="rates-of-deduction"
                    variableWidth
                    :data="tabs">
                    <template slot="gofixTab:rates-of-deduction">
                        <gofix-card title="" class="pt-4" classContent="mb-0">
                            <b-row>
                                <b-col md="3">
                                    <b-row>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                label="Month"
                                                vLabel="label"
                                                v-model="pa_data_entries_header.month"
                                                :reduce="option => option.value"
                                                required
                                                clearable
                                                :options="optionMonth">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="6">
                                            <gofix-form-dropdown
                                                label="Year"
                                                v-model="pa_data_entries_header.year"
                                                required
                                                clearable
                                                :options="optionYear">
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <b-row>
                                        <b-col md="7">
                                            <gofix-form-dropdown
                                                v-bind:class="{'run-loading small-loading': loading}"
                                                label="Select Supplier Contract"
                                                vLabel="contract_title"
                                                @search="searchSupplierContract"
                                                :filterable="false"
                                                v-model="optionSupplierContract"
                                                :options="optionSupplierContracts">
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="5">
                                            <gofix-form-dropdown
                                                label="Select Property Type"
                                                v-model="pa_data_entries_header.property_type"
                                                required
                                                clearable
                                                :options="optionPropertyType">
                                            </gofix-form-dropdown>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="5">
                                    <b-row>
                                        <b-col md="8">
                                            <gofix-form-dropdown
                                                v-bind:class="{'run-loading small-loading': loading}"
                                                label="Location" 
                                                :filterable="false" 
                                                :options="locations" 
                                                :reduce="option => option['location_id']"
                                                v-model="pa_data_entries_header.location_id" 
                                                @search="searchLocation" 
                                                vLabel="name"
                                                show-icon-required>
                                                <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                    <span class="text-hidden-one-row">{{ option.location_path || '-' }}</span>
                                                </template>
                                                <template slot="gofixInput:dropdown:option" slot-scope="option">
                                                    <span v-b-tooltip.hover.top :title="option.location_path" v-html="$options.filters.highlightNode(option.location_path, key_search_property)"></span>
                                                </template>
                                            </gofix-form-dropdown>
                                        </b-col>
                                        <b-col md="4" class="text-center pt-15">
                                            <gofix-button :loading="save_loading" @click="saveData" class="ml-2 mr-2" label="Save"></gofix-button>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card fullContent classContent="mb-0 pt-15 vh-80">
                            <gofix-table :settings="tableConfig"
                                :table-items="tableItems"
                                @row-click="rowClick"
                                @load-items="getTableData"
                                @new-item="rowClick"
                                ref="gofixTable">
                                <template slot="gofix_table:actions_delete" slot-scope="row">
                                    <a class="control-item-link cursor-pointer" @click="deleteItem(row)"> <img src="img/deleteIcon.png" alt="delete" width="20" height="20"> </a>
                                </template>
                                <template slot="gofix_table:id" slot-scope="row">
                                    {{ row.index + 1 }}
                                </template>
                                <template slot="gofix_table:property" slot-scope="row">
                                    {{ row.item.property && row.item.property.name ? row.item.property.name : '--' }}
                                </template>
                                <template slot="gofix_table:user" slot-scope="row">
                                    {{ row.item.user && row.item.user.name ? row.item.user.name : '--' }} {{ row.item.user && row.item.user.email ? '- ' + row.item.user.email : '' }}
                                </template>
                                <template slot="gofix_table:ld_id" slot-scope="row">
                                    {{ row.item.ld_id ? row.item.ld_id : '--' }} 
                                </template>
                                <template slot="gofix_table:ld_date" slot-scope="row">
                                    {{ row.item.ld_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY") }}
                                </template>
                                <template slot="gofix_table:total" slot-scope="row">
                                    {{ row.item.total | formatMoney }}
                                </template>
                            </gofix-table>
                            <b-modal :no-close-on-backdrop="true" id="modal-create-orders" :title="modal.title" hide-footer :centered="true" v-model="modal.open" size="lg" ref="modal-create-orders">
                                <b-form class="formV2">
                                    <div class="property-dropdown-container">
                                        <div class="property-dropdown dropdown-custom-tooltip">
                                            <gofix-form-dropdown label="Property" 
                                            :filterable="false" 
                                            :options="propertiesContracts" 
                                            :class="[{'run-loading small-loading': loading_property} ]" 
                                            @search="searchProperty" 
                                            @change="changeProperty" 
                                            v-model="modal.itemAdd.property"
                                            vLabel="location_path">
                                                <template slot="gofixInput:dropdown:option" slot-scope="option">
                                                    <span v-b-tooltip.hover.top :title="option.location_path" v-html="$options.filters.highlightNode(option.location_path, key_search_property || modal.itemAdd.property)"></span>
                                                </template>
                                            </gofix-form-dropdown>
                                        </div>
                                        <span @click="openModalProperty" class="property-tree-icon"><img src="img/union-icon.png" /></span>
                                    </div>
                                    <gofix-form-dropdown
                                        label="User"
                                        :class="[{'run-loading small-loading': loading_user} ]" 
                                        :multiple="false"
                                        @search="searchUser"
                                        :filterable="false"
                                        :required="true"
                                        v-model="modal.itemAdd.user"
                                        :options="users.data">
                                        <template #gofixInput:dropdown:option="{ name, email }">
                                            {{name}} - {{email}}
                                        </template>
                                        <template #gofixInput:dropdown:selected-option="{ name, email }">
                                            {{name}} - {{email}}
                                        </template>
                                    </gofix-form-dropdown>
                                    <gofix-form-input-date
                                        v-model="modal.itemAdd.ld_date"
                                        label="LD Date">
                                    </gofix-form-input-date>
                                    <gofix-form-dropdown
                                        label="Description"
                                        vLabel="description"
                                        :disabled="modal.index !== null"
                                        v-model="modal.itemAdd.rates_of_deduction_setting"
                                        :options="modal.descriptions">
                                        <template slot="gofixInput:dropdown:option" slot-scope="option">
                                            <span class="d-block" v-b-tooltip.hover.top :title="`($` +  option.rates + `) ` + option.description" v-html="`($` + option.rates + `) ` + option.description"></span>
                                        </template>
                                    </gofix-form-dropdown>
                                    <gofix-form-input-number
                                        label="Quantity"
                                        :includeThousandsSeparator="false"
                                        v-model="modal.itemAdd.quantity"
                                    ></gofix-form-input-number>
                                    <gofix-form-input label="remarks" v-model="modal.itemAdd.remarks"></gofix-form-input>
                                </b-form>
                                <b-modal :no-close-on-backdrop="true" id="modal-property-tree" title="Search Property" hide-footer :centered="true" v-model="modals.properties.open" ref="modal-SearchProperty">
                                    <b-form>
                                        <b-form-group label="" class="mt-0">
                                            <gofix-form-input class="p-color" label="Property" v-model="modals.properties.root_path" disabled required></gofix-form-input>
                                        </b-form-group>
                                        <div class="tree-scrollbar">
                                            <div class="contenAbsolute">
                                                <div class="tree-view-properties">
                                                    <tree ref="tree" :data="treeData" :options="opts" @node:clicked="select">
                                                        <div slot-scope="{ node }" class="node-container"> {{ node.data.name }} </div>
                                                    </tree>
                                                </div>
                                            </div>
                                        </div>
                                    </b-form>
                                    <b-button-group class="d-block text-right p-1rem">
                                        <gofix-button label="APPLY" @click="applyProperty" :loading="modals.properties.loading" noBorder></gofix-button>
                                    </b-button-group>
                                </b-modal>
                                <b-button-group class="d-block text-right pr-4">
                                    <gofix-button label="SUBMIT" @click="calcRow" :loading="modal.loading" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                        </gofix-card>
                        <gofix-card fullContent classContent="mb-0 mt-10 pt-15 pr-25 pl-25 pb-10">
                            <b-row class="mb-3">
                                <div class="action actionFloat actionFloat__extra d-flex font-weight-bold">
                                    <div class="title pl-15">Attachments</div>
                                    <b-button @click="deleteAttachment" v-if="modal.attachmentDeleteId.length">
                                        <div class="tooltip">Delete</div>
                                        <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                            <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                        </svg>
                                    </b-button>
                                    <b-button type="button" @click="modal.attachment.open = true">
                                        <div class="tooltip">Create</div>
                                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                            <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                            <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                        </svg>
                                    </b-button>
                                </div>
                            </b-row>
                            <b-row>
                                <b-col class="col-3 mb-3" v-for="(attachment,index) in modal.attachments" :key="index">
                                    <div class="attachmentInfo">
                                        <div class="checkbox">
                                            <b-form-checkbox class="uniform" :value="index" v-model="modal.attachmentDeleteId"></b-form-checkbox>
                                        </div>
                                        <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                        <div class="name">{{attachment.image_file_title || attachment.image_file_name}}</div>
                                    </div>
                                </b-col>
                                <b-col class="col-3 mb-3" v-for="(attachment,index) in modal.attachment_tmp" :key="'tmp'+index">
                                    <div class="attachmentInfo">
                                        <div class="checkbox">
                                            <b-form-checkbox class="uniform" :value="'tmp'+index" v-model="modal.attachmentDeleteId"></b-form-checkbox>
                                        </div>
                                        <img v-if="checkShowIcon(attachment)" class="icon" :src="attachment | iconFile(icons)" with="24" height="24" alt="icon-file">
                                        <div class="name">{{attachment.image_file_title || attachment.name}}</div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-modal :no-close-on-backdrop="true" title="import file" ref="modal-Import-attachments" id="modal-Contract-Attachments" hide-footer v-model="modal.attachment.open">
                                <b-form class="formV2">
                                    <gofix-form-input label="File Title" v-model="modal.attachment.image_file_title"></gofix-form-input>
                                    <b-form-group :label="modal.attachment.filename">
                                        <b-form-file ref="file-input" v-model="modal.attachment.fileAttachment" ></b-form-file>
                                    </b-form-group>
                                    <b-button-group class="text-right d-block">
                                        <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modal.attachment.loading"></gofix-button>
                                    </b-button-group>
                                </b-form>
                            </b-modal>
                            <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modal.deleteTemplate.open">
                                <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
                                <b-button-group class="btn-group">
                                    <b-button class="custom-btn" @click="modal.deleteTemplate.open = false">No</b-button>
                                    <b-button class="custom-btn" @click="deleteTemplate" :disabled="modal.deleteTemplate.loading">
                                        <b-spinner v-if="modal.deleteTemplate.loading" small type="grow"></b-spinner>Yes
                                    </b-button>
                                </b-button-group>
                            </b-modal>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';
    import LiquorTree from 'liquor-tree';

    export default {
        name: 'pa-data-entries-rates-of-deduction',
        components: {
            [LiquorTree.name]: LiquorTree,
        },
        props: {
            nameTable: {
                type: String,
                default: 'pa-data-entries-rates-of-deduction'
            }
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['pa_rates_of_deduction']));
            return {
                tabs: tabData.performance_assesment_data_entries,
                tableConfig: {
                    name: this.nameTable,
                    controls: {
                        create: true,
                        delete: false,
                        tableColumnSettings: false,
                        tableImport: false,
                        tableExport: false,
                        tableFilter: false,
                        reload: true,
                        tablePagination: false
                    },
                    fields: [
                        {
                            key: 'actions_delete',
                            label: '',
                            thClass: 'text-center',
                            tdClass: 'text-center',
                            width: 50,
                            thStyle: 'width: 50px',
                        },
                        {
                            key: 'id',
                            label: 'S/N',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 100px',
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'user',
                            label: 'PO in Charge',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 200px',
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'ld_id',
                            label: 'LD ID',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 200px',
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'ld_date',
                            label: 'LD Date',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 200px',
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'property',
                            label: 'Address',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 300px',
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'remarks',
                            label: 'Remarks',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 200px',
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'description',
                            label: 'Description',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 200px',
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'unit',
                            label: 'Unit',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 200px',
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'quantity',
                            label: 'Qty',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 100px',
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'total',
                            label: 'Total',
                            isActive: 1,
                            isFilter: false,
                            thStyle: 'width: 150px',
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                        {
                            key: 'auto',
                            label: '',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                    ],
                    filter: filter,
                    page: 1,
                    limit: -1,
                    total: 0,
                    sortDirection: "ASC",
                    isCMS: 0
                },
                tableItems: [],
                pa_data_entries_header: {
                    month: null,
                    year: null,
                    contract_id: null,
                    property_type: 'Residential',
                    location_id: null
                },
                pa_request: null,
                optionMonth: [],
                optionYear: [],
                optionSupplierContract: null,
                optionSupplierContracts: [],
                optionPropertyType: [
                    'Residential',
                    'Hawker Centre'
                ],
                isAction: false,
                timer: null,
                locations: [],
                modal: {
                    open: false,
                    title: null,
                    loading: false,
                    index: null, 
                    descriptions: [],
                    itemAdd: {
                        rates_of_deduction_setting: null,
                        rates_of_deduction_setting_id: null,
                        quantity: null,
                        rates: null,
                        total: null,
                        unit: null,
                        description: null,
                        ld_id: null,
                        ld_date: null,
                        property: null,
                        property_id: null,
                        user: null,
                        user_id: null,
                        remarks: null,
                    },
                    attachments: [],
                    attachmentUpdate: [],
                    attachmentDeleteId: [],
                    attachmentDeleteIds: [],
                    attachment_tmp: [],
                    attachment: {
                        open: false,
                        loading: false,
                        filename: "Click Browse to upload file",
                        fileAttachment: null,
                        image_file_title: '',
                        id: 0,
                        index: '',
                        edit: 0
                    },
                    deleteTemplate:{
                        open: false,
                        loading: false,
                        index: null,
                    },
                },
                loading: false,
                save_loading: false,
                delete_atch_ids: [],
                icons: {
                    'application': {
                        'word': {
                            'img': 'word.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
                        },
                        'excel': {
                            'img': 'excel.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
                        },
                        'pdf': {
                            'img': 'pdf.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                        },
                    },
                    'image': {
                        'img': 'image.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                    },
                    'text': {
                        'img': 'notepad.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                    },
                    'inode': 'none'
                },
                treeData: [],
                selectedNode: null,
                rootId: null,
                opts: {
                    minFetchDelay: 500,
                    fetchData: (node) => {
                        node.isBatch = false;
                        if (node.data.id == this.rootId) {
                            return new Promise((resolve, reject) => {
                                resolve([]);
                            });
                        }
                        return new Promise((resolve, reject) => {
                            global.axios(`api/properties/tree`, {
                                    method: "GET",
                                    params: {
                                        property_id: node.data.id
                                    },
                                    headers: {
                                        Accept: "application/json",
                                    }
                                })
                                .then(response => {
                                    resolve(response.data.data);
                                })
                                .catch(error => reject(error));
                        });
                    }
                },
                propertiesContracts: [],
                loading_property: false,
                timer_property: false,
                modals: {
                    properties: {
                        open: false,
                        loading: false,
                        root_path: null
                    },
                },
                users: {
                    data: [],
                    timer: null,
                },
                loading_user: false,
                filter_property_id: null
            }
        },
        filters: {
            highlightNode(val, option_selected) {
                if(option_selected) {
                    if(option_selected.name) {
                        val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                    } else {
                        let regex = new RegExp(option_selected, "i");
                        let index = val.search(regex);
                        let substr = val.substr(index, option_selected.length);
                        val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                    }
                }
                return val;
            },
            iconFile(val, icons, is_svg = false) {
                let path = 'img/';
                let type_show = 'img';
                let extension = '';
                let type = val.type || val.image_content_type;

                if(is_svg) {
                    path = '';
                    type_show = 'svg';
                }
                if(val.type) extension = val.name.split('.')[1];

                let arrTemp = type.split('/');
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(!extension) extension = arrTemp[1];

                    if(type == 'application' || type == 'inode' || type == 'text') {
                        let key = 'pdf';
                        if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                        if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                        if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                            let extension = val.image_file_name.split('.')[1];
                            if(['doc', 'docx'].includes(extension)) key = 'word';
                            if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                        }
                        return `${path}${icons['application'][key][type_show]}`;
                    }

                    return `${path}${icons[type][type_show]}`;
                }
            }
        },
        created() {
            this.getYear();
            this.getMonth();

            this.pa_data_entries_header.month = parseInt(moment().format('M'))
            this.pa_data_entries_header.year = parseInt(moment().format('YYYY'))
            this.getSupplierContract();
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        watch: {
            ClientContractID: function(val) {
                setTimeout(() => {
                    this.getSupplierContract();
                    this.searchLocation('', () => {})
                }, 2000);
            },
            "pa_data_entries_header.month": function(val){
                if(this.pa_data_entries_header.month && 
                    this.pa_data_entries_header.year && 
                    this.pa_data_entries_header.contract_id &&
                    this.pa_data_entries_header.property_type &&
                    this.pa_data_entries_header.location_id
                ){
                    this.$refs.gofixTable.reloadTableItems();
                }
            },
            "pa_data_entries_header.year": function(val){
                if(this.pa_data_entries_header.month && 
                    this.pa_data_entries_header.year && 
                    this.pa_data_entries_header.contract_id &&
                    this.pa_data_entries_header.property_type &&
                    this.pa_data_entries_header.location_id
                ){
                    this.$refs.gofixTable.reloadTableItems();
                }
            },
            "optionSupplierContract": function(val){
                this.pa_data_entries_header.location_id = null
                if(val.id){
                    this.pa_data_entries_header.contract_id = val.id
                }
                this.searchLocation('', () => {})
            },
            "pa_data_entries_header.property_type": function(val){
                if(this.pa_data_entries_header.month || 
                    this.pa_data_entries_header.year || 
                    this.pa_data_entries_header.contract_id ||
                    this.pa_data_entries_header.property_type ||
                    this.pa_data_entries_header.location_id
                ){
                    if ( this.pa_data_entries_header.location_id ) {
                        this.$refs.gofixTable.reloadTableItems();
                    }
                }
                this.searchLocation('', () => {})
            },
            "pa_data_entries_header.location_id": function(val){
                if(val){
                    this.$refs.gofixTable.reloadTableItems();
                }
            },
            "modal.attachment.fileAttachment": function(val, old) {
                this.modal.attachment.filename = 'Click Browse to upload file';
                if (val) {
                    let extensionAccept = ['csv', 'pdf', 'txt', 'jpeg', 'jpg', 'png', 'gif','msg','html','htm','zip'];
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                    if(!extensionAccept.includes(extension)) {
                        this.$refs['file-input'].reset()
                        return this.$alertNotification("File format is incorrect. Please select a .zip, .html, .msg, .csv, .pdf, .txt, .jpeg, .jpg, .png, .gif file!", "warning");
                    }
                    this.modal.attachment.filename = val.name
                }
            },
        },
        methods: {
            async getTableData(callback){
                
                const { tableRequest , resolve, reject } = await callback();

                if(!this.pa_data_entries_header.month || 
                    !this.pa_data_entries_header.year || 
                    !this.pa_data_entries_header.contract_id ||
                    !this.pa_data_entries_header.property_type ||
                    !this.pa_data_entries_header.location_id
                ){
                    const response = {
                        items: [],
                        total: 0
                    }
                    resolve(response);
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    return;
                }
                
                this.modal.attachment_tmp = []
                this.modal.attachments = []

                tableRequest.filter = this.pa_data_entries_header
                tableRequest.sortColumn = 'id'
                tableRequest.useDatabaseView = false
                tableRequest.limit = -1
                
                await this.$store.dispatch("PAConservancyController/getEntryHeaderRatesOfDeduction", tableRequest)
                .then(response => {
                    this.tableItems = response.entries || []
                    this.tableConfig.total = response.total
                    this.modal.attachments = response.header.attachments || []
                    this.loading = false
                    resolve(response.entries)
                })
                .catch(err => {
                    this.loading = false
                    reject()
                })
            },
            async rowClick(val, index){

                this.searchProperty('', () => {});
                this.getProperties();
                this.getUsers();
                
                if(!this.pa_data_entries_header.month) return this.$alertNotification("Month is required", "danger")
                if(!this.pa_data_entries_header.year) return this.$alertNotification("Year is required", "danger")
                if(!this.pa_data_entries_header.contract_id) return this.$alertNotification("Supplier Contract is required", "danger")
                if(!this.pa_data_entries_header.property_type) return this.$alertNotification("Property Type is required", "danger")
                if(!this.pa_data_entries_header.location_id) return this.$alertNotification("Location is required", "danger")
                
                /**/
                this.modal.loading = true
                
                let tableRequest = {
                    filter: {"contract_id": {"type":"number","value":this.pa_data_entries_header.contract_id,"function":"=","with":[]},"property_type": {"type":"text","value":this.pa_data_entries_header.property_type,"function":"ilike","with":[]}},
                    limit: -1,
                    page: 1,
                    isCMS: 1,
                    sortColumn: 'id',
                    sortDirection: 'ASC',
                    type_setting: 'pa_rates_of_deduction_setting'
                }

                await this.$store.dispatch("PerformanceAssesmentSettingsController/getItems", tableRequest)
                .then(response => {
                    this.modal.descriptions = response.items;
                })
                .catch(err => { })
                
                if ( val ) {
                    this.modal.title = 'Edit Rates of Deduction';
                    this.modal.itemAdd.rates_of_deduction_setting = {
                        "id": val.rates_of_deduction_setting_id,
                        "contract_id": this.pa_data_entries_header.contract_id,
                        "property_type": this.pa_data_entries_header.property_type,
                        "unit": val.unit,
                        "description": val.description,
                        "rates": val.rates,
                    };
                    this.modal.itemAdd.quantity = val.quantity;
                    this.modal.index = index;

                    this.modal.itemAdd.ld_id = val.ld_id;
                    this.modal.itemAdd.ld_date = moment(val.ld_date).toDate();
                    this.modal.itemAdd.property = val.property;
                    this.modal.itemAdd.property_id = val.property_id;
                    this.modal.itemAdd.user = val.user;
                    this.modal.itemAdd.quanuser_idtity = val.user_id;
                    this.modal.itemAdd.remarks = val.remarks;
                } else {
                    this.modal.title = 'Add Rates of Deduction';
                    this.modal.index = null;
                    this.modal.itemAdd.rates_of_deduction_setting = null
                    this.modal.itemAdd.rates_of_deduction_setting_id = null
                    this.modal.itemAdd.quantity = null
                    this.modal.itemAdd.rates = null
                    this.modal.itemAdd.total = null
                    this.modal.itemAdd.unit = null
                    this.modal.itemAdd.description = null
                    this.modal.itemAdd.ld_id = null
                    this.modal.itemAdd.ld_date = null
                    this.modal.itemAdd.property = null
                    this.modal.itemAdd.property_id = null
                    this.modal.itemAdd.user = null
                    this.modal.itemAdd.user_id = null
                    this.modal.itemAdd.remarks = null
                }

                this.modal.loading = false;
                this.modal.open = true;
            },
            getYear(){
                let min_year = 2008;
                let current_year = new Date().getFullYear();
                for(let i = current_year; i >= min_year; i--){
                    this.optionYear.push(i);
                }
            },
            getMonth(){
                let monthsRequired = 12;
                let m = moment("2010-January-01","YYYY-MMMM-DD");
                for (let i = 0; i < monthsRequired; i++) {
                    let mClone = m.clone();
                    this.optionMonth.push({
                        label: mClone.add(i, 'months').format('MMMM'),
                        value:(i+1)
                    })
                }
            },
            searchSupplierContract(search, loading){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getSupplierContract(search);
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
            async getSupplierContract(search = null) {
                this.loading = true
                let tableRequest = {
                    filter: {
                        contract_title: { type: "text", value: search, function: "ilike", with: [] },
                        contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : ""
                    },
                    limit: 100,
                    page: 1,
                    isCMS: 1,
                    useDatabaseView: true,
                    sortColumn: "contract_title",
                    sortDirection: "ASC"
                }
                await this.$store.dispatch("ContractController/getListSContracts", tableRequest)
                .then(response => {

                    this.tableItems = [];
                    this.tableConfig.total = 0;
                    this.pa_data_entries_header.contract_id = null
                    
                    this.optionSupplierContracts = response.data.data.contracts

                    if(search === null) {
                        this.optionSupplierContract = null
                        if(response.data.data.contracts[0].id){
                            this.pa_data_entries_header.contract_id = response.data.data.contracts[0].id
                            this.optionSupplierContract = response.data.data.contracts[0]
                        }
                    }
                    
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
            },
            calcRow(){

                if(!this.modal.itemAdd.rates_of_deduction_setting) return this.$alertNotification("Description is required", "danger")
                if(!this.modal.itemAdd.quantity) return this.$alertNotification("Quantity is required", "danger")
                if(!this.modal.itemAdd.property) return this.$alertNotification("Adress is required", "danger")
                if(!this.modal.itemAdd.user) return this.$alertNotification("User is required", "danger")

                let index = this.modal.index;

                /**/
                /* if ( index === null ) {
                    let flag = 0
                    this.tableItems.map(item => {
                        if ( item.rates_of_deduction_setting_id == this.modal.itemAdd.rates_of_deduction_setting.id && item.property_id == this.modal.itemAdd.property.id ) {
                            flag = 1
                        }
                    });

                    if ( flag == 1 ) return this.$alertNotification("Description is existing", "danger")
                } */

                let total = 0
                if ( this.modal.itemAdd && this.modal.itemAdd.rates_of_deduction_setting && this.modal.itemAdd.rates_of_deduction_setting.rates && this.modal.itemAdd.quantity ) {
                    total = parseInt(this.modal.itemAdd.rates_of_deduction_setting.rates) * parseInt(this.modal.itemAdd.quantity)
                }
                
                if ( index === null ) {
                    this.tableItems.push({
                        rates_of_deduction_setting_id: this.modal.itemAdd.rates_of_deduction_setting.id,
                        quantity: this.modal.itemAdd.quantity,
                        description: this.modal.itemAdd.rates_of_deduction_setting.description,
                        rates: this.modal.itemAdd.rates_of_deduction_setting.rates,
                        unit: this.modal.itemAdd.rates_of_deduction_setting.unit,
                        ld_id: '',
                        ld_date: moment(new Date(this.modal.itemAdd.ld_date)).format("YYYY-MM-DD"),
                        property: this.modal.itemAdd.property,
                        property_id: this.modal.itemAdd.property.id,
                        user: this.modal.itemAdd.user,
                        user_id: this.modal.itemAdd.user.id,
                        remarks: this.modal.itemAdd.remarks,
                        total: total,
                    })
                } else {
                    this.tableItems[index].rates_of_deduction_setting_id = this.modal.itemAdd.rates_of_deduction_setting.id;
                    this.tableItems[index].quantity = this.modal.itemAdd.quantity;

                    this.tableItems[index].description = this.modal.itemAdd.rates_of_deduction_setting.description;
                    this.tableItems[index].rates = this.modal.itemAdd.rates_of_deduction_setting.rates;
                    this.tableItems[index].unit = this.modal.itemAdd.rates_of_deduction_setting.unit;

                    this.tableItems[index].ld_id = this.modal.itemAdd.ld_id;
                    this.tableItems[index].ld_date = moment(new Date(this.modal.itemAdd.ld_date)).format("YYYY-MM-DD");
                    this.tableItems[index].property = this.modal.itemAdd.property;
                    this.tableItems[index].property_id = this.modal.itemAdd.property.id;
                    this.tableItems[index].user = this.modal.itemAdd.user;
                    this.tableItems[index].user_id = this.modal.itemAdd.user.id;
                    this.tableItems[index].remarks = this.modal.itemAdd.remarks;

                    this.tableItems[index].total = total;
                }
                
                this.modal.open = false;
                
                /* save data */
                if ( this.pa_request ) {
                    this.pa_request.items = Object.assign([], this.tableItems)
                }
            },
            searchLocation(search, loading) {
                this.loading = true
                this.locations = []
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.key_search_property = search;

                    const property_root_id = this.optionSupplierContract ? this.optionSupplierContract.property_root_id : null
                    const contract_id = this.optionSupplierContract ? this.optionSupplierContract.id : null
                    
                    this.$store.dispatch('PerformanceAssesmentSettingsController/getItems', {
                        keyword: search,
                        property_root_id: property_root_id,
                        type_setting: 'pa_contract_sum_setting',
                        filter: {
                            contract_id: contract_id,
                            property_type: this.pa_data_entries_header.property_type,
                            location_name: ''
                        },
                        sortColumn: 'location_name',
                        sortDirection: 'ASC',
                    })
                    .then(response => {
                        this.locations = response.items
                        this.loading = false
                    })
                    .catch(err => {
                        this.loading = false
                    })
                }, 500);
            },
            saveData(){
                if(!this.pa_data_entries_header.month || 
                    !this.pa_data_entries_header.year || 
                    !this.pa_data_entries_header.contract_id ||
                    !this.pa_data_entries_header.property_type ||
                    !this.pa_data_entries_header.location_id
                ){
                    return this.$alertNotification("The field is required", "danger");
                }
                
                this.save_loading = true;
                
                if(!this.pa_request){
                    this.pa_request = {
                        year: this.pa_data_entries_header.year,
                        month: this.pa_data_entries_header.month,
                        contract_id: this.pa_data_entries_header.contract_id,
                        property_type: this.pa_data_entries_header.property_type,
                        location_id: this.pa_data_entries_header.location_id,
                        items: Object.assign([], this.tableItems),
                        delete_atch_ids: this.modal.attachmentDeleteIds,
                        attachments: this.modal.attachment_tmp,
                    };
                }
                
                this.$store.dispatch(`PAConservancyController/saveDataEntriesRatesOfDeduction`, this.pa_request)
                .then(response => {
                    this.pa_request = null;
                    this.save_loading = false;
                    this.tableItems = response.entries;
                    this.modal.attachment_tmp = []
                    this.modal.attachmentDeleteIds = []
                    this.modal.attachments = response.header.attachments || []
                    return this.$alertNotification("Saved successfully", "success");
                })
                .catch(err => {
                    this.pa_request = null;
                    this.save_loading = false;
                    this.modal.attachmentDeleteIds = []
                    this.modal.attachment_tmp = [];

                    if (err.response.data.error && err.response.data.error.message) {
                        this.$alertNotification(err.response.data.error.message, "danger")
                    }
                })
            },
            generalKeyId(){
                return String(
                    Date.now().toString(32) +
                    Math.random().toString(16)
                ).replace(/\./g, '')
            },
            deleteItem(val) {
                this.modal.deleteTemplate.index = val.index
                this.modal.deleteTemplate.open = true
            },
            deleteTemplate() {
                this.$delete(this.tableItems, this.modal.deleteTemplate.index)
                this.$alertNotification("Successfully deleted Rates of Deduction", "success")
                this.modal.deleteTemplate.index = null
                this.modal.deleteTemplate.open = false
            },
            addAttachment() {
                if(!this.modal.attachment.fileAttachment) {
                    return this.$bvToast.toast('Please select the file.', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                if ( this.modal.attachment.image_file_title ) {
                    this.modal.attachment.fileAttachment.image_file_title = this.modal.attachment.image_file_title;
                } else {
                    this.modal.attachment.fileAttachment.image_file_title = this.modal.attachment.fileAttachment.name
                }
                
                this.modal.attachment.fileAttachment.id_tmp = `tmp_${this.generalKeyId()}`
                this.modal.attachment_tmp.push(this.modal.attachment.fileAttachment);

                this.modal.attachment.fileAttachment = null;
                this.modal.attachment.image_file_title = null;
                this.modal.attachment.open = false;
                this.modal.attachment.filename = "Click Browse to upload file";
                this.modal.attachment.id = 0;
                this.modal.attachment.index = 0;
                this.modal.attachment.edit = 0;
            },
            checkShowIcon(val){
                if(!val) return false;
                let type = val.type || val.image_content_type;
                if(!type) return false;
                let arrTemp = type.split('/');
                if(!arrTemp || arrTemp.length < 2 || !this.icons[arrTemp[0]]) return false;
                return true;
            },
            deleteAttachment(){
                if(this.modal.attachmentDeleteId.length > 0){
                    this.modal.attachmentDeleteId = this.modal.attachmentDeleteId.sort().reverse();
                    for(let index of this.modal.attachmentDeleteId){
                        if( typeof(index) == "string" && index.includes("tmp")) {
                            index = index.slice(3);
                            let item = this.modal.attachment_tmp.splice(index, 1);
                        } else {
                            let item = this.modal.attachments.splice(index, 1);
                            this.modal.attachmentDeleteIds.push(item[0].id)
                        }
                    }
                }
                this.modal.attachmentDeleteId.length = 0;
            },
            /* property */
            getProperties() {
                return new Promise((resolve, reject) => {
                    global.axios(`api/properties/search`, {
                        method: "GET",
                        params: {
                            // contract_id: this.pa_data_entries_header.contract_id,
                            property_root_id: this.pa_data_entries_header.location_id,
                            // self: 1,
                            is_active: true,
                            is_tree: true
                        },
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        response.data.data[0].state = {
                            selected: true,
                            expanded: true
                        };
                        this.treeData = response.data.data
                        this.rootId = response.data.data[0].id;
                        resolve(response.data.data);
                    })
                    .catch(error => reject(error));
                });
            },
            openModalProperty() {
                this.getProperties();
                this.modals.properties.open = true;
            },
            searchProperty(search, loading) {
                loading(true);
                this.loading_property = true;
                this.propertiesContracts = []
                if (this.timer_property) {
                    clearTimeout(this.timer_property);
                    this.timer_property = null;
                }
                this.timer_property = setTimeout(() => {
                    this.key_search_property = search;
                    this.$store.dispatch('PropertyController/getSearchProperties', {
                            keyword: search,
                            // contract_id: this.pa_data_entries_header.contract_id,
                            property_root_id: this.pa_data_entries_header.location_id,
                            limit: 100,
                            is_active: true,
                            self: 1,
                        })
                        .then(response => {
                            this.propertiesContracts = response
                            this.loading_property = false;
                            loading(false);
                        })
                        .catch(err => {
                            loading(false);
                            this.loading_property = false;
                        })
                }, 500);
            },
            changeProperty(val) {
                this.modal.itemAdd.property = val;
                this.modals.properties.root_path = (val && val.root_path) ? val.root_path : null;

                this.filter_property_id = val.id;
                this.modal.itemAdd.user = '';
                this.searchUser();
            },
            applyProperty() {
                if (this.selectedNode) {
                    let property = Object.assign({}, this.selectedNode);
                    let arr_tmp = property.root_path.split(' >> ');
                    if(arr_tmp.length > 1) {
                        arr_tmp.shift();
                        property.location_path = arr_tmp.join(" >> ");
                    } else {
                        property.location_path = property.root_path;
                    }
                    this.modal.itemAdd.property = property;
                }
                this.modals.properties.open = false;
            },
            select(node) {
                this.selectedNode = node.data
                this.modals.properties.root_path = node.data.root_path
            },
            /* user duty */
            getUsers(){
                this.loading_user = true
                this.$store.dispatch("v2UserController/searchListUser", { page: 1, totalPage: 0, limit: 100, filters: { name: '', organization_isfm : true, client_contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null, property_id: this.filter_property_id } })
                .then(result=>{
                    this.users.data = result.data
                    this.loading_user = false
                })
                .catch(err => {
                    this.loading_user = false
                    console.log(err);
                })
            },
            searchUser (search, loading){
                this.loading_user = true
                if(this.users.timer) {
                    clearTimeout(this.users.timer);
                    this.users.timer = null;
                }
                this.users.timer = setTimeout(() => {
                    this.$store.dispatch("v2UserController/searchListUser", { page: 1, totalPage : 0, limit: 1000, filters: { name: search, or: true, email: search, organization_isfm : true, client_contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null, property_id: this.filter_property_id }})
                        .then(response => {
                           this.users.data = response.data
                           this.loading_user = false
                        })
                        .catch(err=>{ this.loading_user = false })
                }, 500);
            },
        }
    }
</script>